// extracted by mini-css-extract-plugin
export default {"root":"Heading_root__qWUjB"};